import {
  IAugmentedJQuery,
  IComponentOptions,
  IController,
  IDocumentService,
  INgModelController,
  IPromise,
  IScope,
  ITimeoutService
} from 'angular';
import './gmc-select-4.component.scss';
import { checkInsideClick } from '../../../helpers/check-inside-click';
import { SmartServicesService } from '../../../core/services/smart-services/smart-services.service';

export class GmcSelect4Controller implements IController {
  static $inject = [
    '$scope',
    '$element',
    '$document',
    '$timeout',
    'SmartServicesService'
  ];
  onOpen: () => IPromise<any>;
  confirm: ($event: any) => void;
  value: string;
  isActive = false;
  section: string;
  maxHeight = 180;
  placeholder = 'Select';
  selectedValues: any[] = [];
  options: any[];
  _options: any[] = [];
  noOptions = 'No options';
  position = 'right';
  loading = false;
  disabled: boolean;
  availableEmployers: any = 0;
  index: number;
  vesselTypeCounter: {
    [p: string]: number;
  };

  protected ngModel: INgModelController;

  constructor(
    private $scope: IScope,
    private $element: IAugmentedJQuery,
    private $document: IDocumentService,
    private $timeout: ITimeoutService,
    private smartServicesService: SmartServicesService
  ) {
    this.documentClickListener = this.documentClickListener.bind(this);
  }

  $onInit() {
    this.initOutsideClickListener();
    this.filterData();
    this.checkEmployers(true);
  }

  $onDestroy() {
    this.$document.off('click', this.documentClickListener);
  }

  filterData() {
    console.log(this.section);
    this._options = this.options.filter(
      (value) => value.section_id === this.section
    );
    console.log(this._options);
  }

  onFocus() {
    this.isActive = true;
    this.emitOpened();
  }

  toggle(event) {
    event.preventDefault();
    if (this.isActive) {
      this.close();
    } else {
      this.isActive = true;
      this.emitOpened();
    }
  }

  selectAll() {
    this.selectedValues = this._options.map((value) => value._id);
    this.checkEmployers();
    this.close();
  }

  selectOption(event, option: any, index: number) {
    event.preventDefault();
    console.log(this.selectedValues.indexOf(option._id));
    if (this.selectedValues.indexOf(option._id) < 0) {
      this.selectedValues.splice(index, 0, option._id);
    } else {
      this.selectedValues.splice(this.selectedValues.indexOf(option._id), 1);
    }
    console.log(index);
    console.log(this.selectedValues);
    this.checkEmployers();
  }

  checkEmployers(firstTime: boolean = false) {
    this.smartServicesService
      .presendCvCheck({
        vessel_types: this.selectedValues.length
          ? this.selectedValues
          : [...this._options.map((option) => option._id)]
      })
      .then((res) => {
        res.sections
          .filter((value) => value._id === this.section)
          .map((value) => {
            if (firstTime) {
              this.vesselTypeCounter =
                value.vessel_types_counter;
              return;
            }
            this.availableEmployers = value.count;
          });
      });
  }

  private emitOpened() {
    const cb = this.onOpen();
    if (cb && typeof cb.then === 'function') {
      this.loading = true;
      cb.then((data = []) => {
        this.loading = false;
        this.options = data;
        this.focusSearch();
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    } else {
      this.focusSearch();
    }
  }

  private close() {
    this.isActive = false;
    this.options = this._options;
    this.confirm({ $event: { [this.section]: this.selectedValues } });
  }

  private documentClickListener(event) {
    if (!this.isActive) {
      return;
    }
    if (!checkInsideClick(this.$element[0], event)) {
      this.$scope.$apply(() => {
        this.close();
      });
    }
  }

  private initOutsideClickListener() {
    this.$document.on('click', this.documentClickListener);
  }

  private focusSearch() {
    this.$timeout(() => {
      this.$element.find('.gmc-select4__search-input').focus();
    }, 100);
  }
}

export const GmcSelect4Component: IComponentOptions = {
  controller: GmcSelect4Controller,
  template: require('./gmc-select-4.component.html'),
  bindings: {
    options: '<',
    section: '<',
    disabled: '<',
    index: '<',
    placeholder: '@?',
    maxHeight: '@?',
    noOptions: '@?',
    position: '@?',
    onOpen: '&',
    filter: '<?',
    other: '<',
    confirm: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-select-4/gmc-select-4.component.ts